<div style="text-align: center;width: 100%;font-family: 'Roboto';font-size: 4vw;">
  Tabela de consulta do {{censo}}
</div>
<div style="text-align: center;width: 100%;">
  <span style="font-family: 'Roboto';font-weight: bolder;">Busca:</span>
  <input type="text" pInputText [(ngModel)]="filt" (ngModelChange)="filtrando()"> 
</div>

<span><b>Pendente:</b> O segurado ainda não realizou o censo.</span><br>
<span><b>Inconsistente:</b> Requer que o segurado entre novamente no aplicativo para corrigir algum dado necessário.</span><br>
<span><b>Aguardando:</b> O segurado já submeteu os dados, porém nossa equipe ainda não os analisou.</span><br>
<span><b>Concluido:</b> O Censo consta como completo e o segurado pode entrar no aplicativo para emitir o comprovante.</span><br>
<hr>
{{filtro?filtro.length:0}} segurados pendentes.
<p-table [value]="filtro">
  <ng-template pTemplate="header">
      <tr>
          <th>Nome</th>
          <th>Situação</th>
          <th>Secretaria</th>
      </tr>
  </ng-template>
  <ng-template pTemplate="body" let-car>
      <tr style="text-align: center;">
          <td style="text-align: left;margin-left: 3px;">{{car.nome}}</td>
          <td style="font-weight: bolder;font-size: 18px;text-transform: uppercase;">{{car.situacao}}</td>
          <td style="font-weight: bolder;font-size: 18px;text-transform: uppercase;">{{car.secretaria}}</td>
      </tr>
  </ng-template>
</p-table>